var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g3, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _g4, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 604,
    height: 586,
    viewBox: "0 0 604 586",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M603.934 556.146V547.437L601.544 546.095C600.864 550.197 596.026 552.919 591.965 553.482L564.432 569.598L552.423 573.933L514.048 554.124L514.941 553.619C511.658 552.083 509.889 548.584 508.121 545.376L505.537 546.912L504.002 547.359V556.282C504.104 557.296 504.469 558.266 505.062 559.095C505.656 559.924 506.456 560.583 507.383 561.006L545.875 583.206C548.407 584.481 551.202 585.146 554.036 585.146C556.871 585.146 559.666 584.481 562.197 583.206L600.631 561.006C601.542 560.588 602.329 559.943 602.918 559.133C603.507 558.323 603.877 557.374 603.993 556.379C604.002 556.302 604.002 556.223 603.993 556.146H603.934Z",
    fill: "url(#paint0_linear_1_535)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M591.964 553.482L564.431 569.598L553.977 573.37V585.15C556.819 585.209 559.628 584.54 562.138 583.206L600.572 561.006C601.483 560.588 602.27 559.943 602.859 559.133C603.448 558.323 603.818 557.374 603.934 556.379C603.944 556.302 603.944 556.223 603.934 556.146V547.437L601.738 546.212H601.505C600.767 550.255 595.987 552.841 591.964 553.482Z",
    fill: "#0F054C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M545.876 574.342L507.442 552.141C502.934 549.556 502.934 545.318 507.442 542.713L545.876 520.512C548.407 519.237 551.202 518.573 554.037 518.573C556.871 518.573 559.666 519.237 562.198 520.512L600.632 542.713C605.12 545.318 605.12 549.556 600.632 552.141L562.198 574.342C559.669 575.626 556.873 576.295 554.037 576.295C551.201 576.295 548.405 575.626 545.876 574.342Z",
    fill: "url(#paint1_linear_1_535)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M545.876 574.342L507.442 552.141C502.934 549.556 502.934 545.318 507.442 542.713L545.876 520.512C548.407 519.237 551.202 518.573 554.037 518.573C556.871 518.573 559.666 519.237 562.198 520.512L600.632 542.713C605.12 545.318 605.12 549.556 600.632 552.141L562.198 574.342C559.669 575.626 556.873 576.295 554.037 576.295C551.201 576.295 548.405 575.626 545.876 574.342Z",
    fill: "#0F054C"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M553.977 546.29C551.454 546.335 548.96 545.74 546.73 544.56L508.296 522.359C507.388 522.04 506.602 521.447 506.045 520.662C505.489 519.877 505.19 518.938 505.19 517.975C505.19 517.013 505.489 516.074 506.045 515.289C506.602 514.504 507.388 513.91 508.296 513.592L546.73 491.391C548.975 490.26 551.454 489.67 553.968 489.67C556.482 489.67 558.96 490.26 561.206 491.391L599.659 513.592C600.567 513.91 601.353 514.504 601.909 515.289C602.466 516.074 602.764 517.013 602.764 517.975C602.764 518.938 602.466 519.877 601.909 520.662C601.353 521.447 600.567 522.04 599.659 522.359L561.225 544.56C558.994 545.74 556.501 546.335 553.977 546.29ZM553.977 490.341C551.571 490.293 549.191 490.855 547.06 491.974L508.626 514.175C507.828 514.44 507.134 514.95 506.642 515.632C506.15 516.314 505.885 517.134 505.885 517.975C505.885 518.817 506.15 519.636 506.642 520.319C507.134 521.001 507.828 521.511 508.626 521.776L547.06 543.976C549.202 545.059 551.568 545.624 553.968 545.624C556.367 545.624 558.734 545.059 560.875 543.976L599.309 521.737C600.107 521.472 600.802 520.962 601.294 520.28C601.786 519.598 602.051 518.778 602.051 517.936C602.051 517.095 601.786 516.275 601.294 515.593C600.802 514.911 600.107 514.401 599.309 514.136L560.875 491.935C558.747 490.832 556.374 490.283 553.977 490.341Z",
    fill: "#42E8E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M603.934 509.451V496.29L601.544 494.949C600.864 499.07 596.026 501.772 591.965 502.336L564.432 518.452L552.423 522.787L514.048 502.977L514.941 502.472C511.658 500.936 509.889 497.437 508.121 494.229L505.537 495.765L504.002 496.212V509.587C504.104 510.601 504.469 511.571 505.062 512.4C505.656 513.229 506.456 513.888 507.383 514.311L545.875 536.511C548.404 537.795 551.2 538.465 554.036 538.465C556.872 538.465 559.668 537.795 562.197 536.511L600.631 514.311C601.542 513.893 602.329 513.248 602.918 512.438C603.507 511.628 603.877 510.679 603.993 509.684C604.002 509.607 604.002 509.528 603.993 509.451H603.934Z",
    fill: "#42E8E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M603.934 497.748V489.039L601.544 487.697C600.864 491.819 596.026 494.521 591.965 495.085L564.432 511.2L552.423 515.535L514.048 495.726L514.941 495.221C511.658 493.685 509.889 490.186 508.121 486.978L505.537 488.533L504.002 488.961V497.884C504.104 498.898 504.469 499.868 505.062 500.697C505.656 501.526 506.456 502.185 507.383 502.608L545.875 524.808C548.404 526.092 551.2 526.762 554.036 526.762C556.872 526.762 559.668 526.092 562.197 524.808L600.631 502.608C601.542 502.19 602.329 501.545 602.918 500.735C603.507 499.925 603.877 498.976 603.993 497.981C604.002 497.904 604.002 497.825 603.993 497.748H603.934Z",
    fill: "url(#paint2_linear_1_535)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M591.964 495.084L564.431 511.2L553.977 514.971V526.752C556.819 526.81 559.628 526.141 562.138 524.808L600.572 502.607C601.483 502.19 602.27 501.545 602.859 500.735C603.448 499.924 603.818 498.976 603.934 497.981C603.944 497.903 603.944 497.825 603.934 497.747V489.038L601.738 487.813H601.505C600.767 491.857 595.987 494.52 591.964 495.084Z",
    fill: "#0F054C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M545.876 515.904L507.442 493.704C502.934 491.099 502.934 486.861 507.442 484.275L545.876 462.133C548.405 460.849 551.201 460.18 554.037 460.18C556.873 460.18 559.669 460.849 562.198 462.133L600.632 484.334C605.12 486.919 605.12 491.157 600.632 493.762L562.139 515.904C559.615 517.17 556.831 517.829 554.008 517.829C551.184 517.829 548.4 517.17 545.876 515.904Z",
    fill: "url(#paint3_linear_1_535)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M600.572 493.763L562.138 515.905C559.606 517.18 556.811 517.844 553.977 517.844C551.143 517.844 548.348 517.18 545.816 515.905L507.382 493.705C506.543 493.309 505.806 492.727 505.227 492.002C504.647 491.278 504.241 490.43 504.04 489.525C503.768 491.469 504.895 493.413 507.382 494.774L545.874 517.033C548.403 518.317 551.199 518.986 554.035 518.986C556.871 518.986 559.667 518.317 562.196 517.033L600.63 494.832C601.656 494.405 602.526 493.672 603.121 492.733C603.715 491.794 604.006 490.694 603.953 489.583C603.746 490.492 603.333 491.341 602.747 492.066C602.161 492.79 601.417 493.371 600.572 493.763Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M534.677 488L447.253 435.683L419.458 451.718H419.135L365 419.81L365.323 419L419.458 450.746L447.253 434.711L447.899 435.035L535 487.19L534.677 488Z",
    fill: "url(#paint4_linear_1_535)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M99.9996 555.204V546.494L97.5889 545.153C96.9085 549.274 92.068 551.977 88.0245 552.54L60.4585 568.656L48.4446 572.991L10.0505 553.182L10.9448 552.676C7.65942 551.141 5.89036 547.641 4.12132 544.434L1.53582 545.989L4.05312e-05 546.417V555.34C0.1018 556.354 0.467642 557.324 1.06115 558.153C1.65466 558.982 2.45508 559.641 3.38259 560.064L41.835 582.264C44.3651 583.548 47.1624 584.218 49.9998 584.218C52.8371 584.218 55.6345 583.548 58.1646 582.264L96.6169 560.064C97.5314 559.649 98.3232 559.005 98.9158 558.194C99.5084 557.384 99.8817 556.434 99.9996 555.437C99.9996 555.437 99.9996 555.281 99.9996 555.204Z",
    fill: "url(#paint5_linear_1_535)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M88.024 552.578L60.458 568.694L49.9993 572.466V584.246C52.8421 584.305 55.6526 583.636 58.164 582.302L96.6164 560.102C97.5308 559.687 98.3227 559.043 98.9153 558.233C99.5079 557.422 99.8812 556.472 99.999 555.475C99.999 555.475 99.999 555.319 99.999 555.242V546.533L97.7828 545.308H97.5496C96.8108 549.313 92.0286 551.976 88.024 552.578Z",
    fill: "#0F054C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M41.8349 573.419L3.38257 551.218C-1.12752 548.613 -1.12752 544.375 3.38257 541.79L41.8349 519.531C44.3651 518.247 47.1624 517.577 49.9998 517.577C52.8371 517.577 55.6344 518.247 58.1646 519.531L96.6169 541.731C101.108 544.317 101.108 548.555 96.6169 551.16L58.1646 573.419C55.6317 574.694 52.8355 575.358 49.9998 575.358C47.1641 575.358 44.3678 574.694 41.8349 573.419Z",
    fill: "url(#paint6_linear_1_535)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M41.8354 573.419L3.38298 551.218C-1.12711 548.613 -1.12711 544.375 3.38298 541.79L41.8354 519.531C44.3655 518.247 47.1628 517.577 50.0002 517.577C52.8375 517.577 55.6348 518.247 58.165 519.531L96.6173 541.731C101.108 544.317 101.108 548.555 96.6173 551.16L58.165 573.419C55.6321 574.694 52.8359 575.358 50.0002 575.358C47.1645 575.358 44.3682 574.694 41.8354 573.419Z",
    fill: "#0F054C"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9998 541.11C47.4743 541.165 44.9771 540.569 42.7486 539.379L4.29623 517.179C3.3948 516.856 2.61517 516.262 2.06396 515.479C1.51275 514.696 1.2169 513.762 1.2169 512.805C1.2169 511.847 1.51275 510.913 2.06396 510.13C2.61517 509.347 3.3948 508.754 4.29623 508.431L42.7486 486.23C44.9955 485.09 47.4799 484.495 49.9998 484.495C52.5196 484.495 55.0039 485.09 57.2508 486.23L95.7032 508.431C96.6047 508.754 97.3843 509.347 97.9356 510.13C98.4868 510.913 98.7826 511.847 98.7826 512.805C98.7826 513.762 98.4868 514.696 97.9356 515.479C97.3843 516.262 96.6047 516.856 95.7032 517.179L57.2508 539.379C55.0224 540.569 52.5252 541.165 49.9998 541.11ZM43.0791 538.796C45.2218 539.879 47.5891 540.444 49.99 540.444C52.3909 540.444 54.7582 539.879 56.9009 538.796L95.3533 516.596C96.2123 516.4 96.9793 515.918 97.5288 515.229C98.0782 514.541 98.3774 513.686 98.3774 512.805C98.3774 511.924 98.0782 511.069 97.5288 510.38C96.9793 509.691 96.2123 509.21 95.3533 509.014L56.9009 486.814C54.761 485.721 52.3926 485.152 49.99 485.152C47.5874 485.152 45.2191 485.721 43.0791 486.814L4.62674 509.014C3.76775 509.21 3.00072 509.691 2.4513 510.38C1.90189 511.069 1.60264 511.924 1.60264 512.805C1.60264 513.686 1.90189 514.541 2.4513 515.229C3.00072 515.918 3.76775 516.4 4.62674 516.596L43.0791 538.796Z",
    fill: "#42E8E0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M99.9995 504.29V491.11L97.5889 489.768C96.9085 493.89 92.068 496.592 88.0244 497.155L60.4585 513.271L48.4445 517.587L10.0505 497.778L10.9447 497.272C7.65938 495.736 5.89032 492.237 4.12128 489.03L1.53578 490.585L0 491.012V504.407C0.0933683 505.421 0.456185 506.392 1.05091 507.219C1.64563 508.046 2.45061 508.7 3.38255 509.111L41.8349 531.312C44.365 532.596 47.1624 533.265 49.9998 533.265C52.8371 533.265 55.6344 532.596 58.1645 531.312L96.6169 509.111C97.5313 508.696 98.3232 508.052 98.9158 507.242C99.5084 506.431 99.8817 505.482 99.9995 504.484C99.9995 504.484 99.9995 504.329 99.9995 504.251V504.29Z",
    fill: "#42E8E0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9995 492.568V483.859L97.5889 482.517C96.9085 486.638 92.068 489.341 88.0244 489.904L60.4585 506.02L48.4445 510.355L10.0505 490.546L10.9447 490.04C7.65938 488.505 5.89032 485.006 4.12128 481.817L1.53578 483.353L0 483.781V492.723C0.105005 493.734 0.472354 494.7 1.06568 495.525C1.659 496.35 2.45768 497.006 3.38255 497.428L41.8349 519.628C44.365 520.912 47.1624 521.582 49.9998 521.582C52.8371 521.582 55.6344 520.912 58.1645 519.628L96.6169 497.428C97.5313 497.013 98.3232 496.369 98.9158 495.559C99.5084 494.748 99.8817 493.798 99.9995 492.801C99.9995 492.801 99.9995 492.645 99.9995 492.568Z",
    fill: "url(#paint7_linear_1_535)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8349 510.783L3.38257 488.582C-1.12752 485.977 -1.12752 481.739 3.38257 479.154L41.8349 456.953C44.3651 455.669 47.1624 455 49.9998 455C52.8371 455 55.6344 455.669 58.1646 456.953L96.6169 479.154C101.108 481.759 101.108 485.977 96.6169 488.582L58.1646 510.783C55.6344 512.067 52.8371 512.736 49.9998 512.736C47.1624 512.736 44.3651 512.067 41.8349 510.783Z",
    fill: "url(#paint8_linear_1_535)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0001 506.739C47.7192 506.79 45.4633 506.255 43.4488 505.184L13.414 487.843C12.5927 487.552 11.8818 487.013 11.3791 486.301C10.8764 485.589 10.6066 484.739 10.6066 483.868C10.6066 482.996 10.8764 482.146 11.3791 481.434C11.8818 480.723 12.5927 480.184 13.414 479.892L43.4488 462.552C45.4778 461.518 47.7228 460.978 50.0001 460.978C52.2775 460.978 54.5225 461.518 56.5514 462.552L86.5863 479.892C87.4075 480.184 88.1183 480.723 88.621 481.434C89.1237 482.146 89.3936 482.996 89.3936 483.868C89.3936 484.739 89.1237 485.589 88.621 486.301C88.1183 487.013 87.4075 487.552 86.5863 487.843L56.5514 505.184C54.5369 506.255 52.281 506.79 50.0001 506.739ZM43.7793 504.601C45.7036 505.579 47.8317 506.089 49.9904 506.089C52.1491 506.089 54.2772 505.579 56.2015 504.601L86.2558 487.26C86.9769 487.032 87.6066 486.581 88.0536 485.971C88.5007 485.361 88.7416 484.624 88.7416 483.868C88.7416 483.112 88.5007 482.375 88.0536 481.765C87.6066 481.155 86.9769 480.703 86.2558 480.476L56.2015 463.154C54.2772 462.176 52.1491 461.666 49.9904 461.666C47.8317 461.666 45.7036 462.176 43.7793 463.154L13.7445 480.495C13.0694 480.789 12.4848 481.257 12.0509 481.851C11.6169 482.446 11.3493 483.145 11.2755 483.878C11.3518 484.612 11.6202 485.312 12.0537 485.91C12.4871 486.507 13.0703 486.979 13.7445 487.28L43.7793 504.601Z",
    fill: "#5351AF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6166 488.583L58.1642 510.783C55.6341 512.067 52.8368 512.737 49.9994 512.737C47.1621 512.737 44.3647 512.067 41.8346 510.783L3.38222 488.583C2.54314 488.187 1.80565 487.605 1.22613 486.88C0.646599 486.156 0.240377 485.309 0.0385328 484.403C-0.0059178 485.517 0.290322 486.618 0.887729 487.559C1.48514 488.501 2.35532 489.237 3.38222 489.671L41.8346 511.872C44.3674 513.147 47.1637 513.811 49.9994 513.811C52.8351 513.811 55.6314 513.147 58.1642 511.872L96.6166 489.671C97.6432 489.239 98.5124 488.502 99.1069 487.56C99.7013 486.618 99.9924 485.516 99.9409 484.403C99.7425 485.307 99.3397 486.154 98.7635 486.878C98.1873 487.603 97.4529 488.186 96.6166 488.583Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7094 503.441L141.839 453.308L169.723 468.352L170.046 468.35L224.002 437.768L223.674 437.002L169.718 467.43L141.834 452.386L141.189 452.697L54.3817 502.675L54.7094 503.441Z",
    fill: "url(#paint9_linear_1_535)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M602.903 202.896V194.187L600.495 192.845C599.815 196.947 594.979 199.669 590.94 200.232L563.4 216.329L551.398 220.683L513.041 200.874L513.934 200.349C510.652 198.833 508.885 195.314 507.117 192.126L504.534 193.662L503 194.089V203.032C503.091 204.047 503.453 205.019 504.047 205.846C504.642 206.674 505.447 207.326 506.379 207.736L544.795 229.937C547.322 231.221 550.117 231.89 552.952 231.89C555.786 231.89 558.581 231.221 561.109 229.937L599.524 207.736C600.438 207.322 601.229 206.678 601.821 205.867C602.413 205.057 602.786 204.107 602.903 203.11V202.896Z",
    fill: "url(#paint10_linear_1_535)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M590.939 200.232L563.4 216.329L552.951 220.119V231.9C555.791 231.959 558.599 231.289 561.108 229.956L599.523 207.756C600.437 207.341 601.228 206.697 601.82 205.886C602.412 205.076 602.785 204.126 602.903 203.129V202.915V194.206L600.708 192.981H600.475C599.698 197.005 594.94 199.669 590.939 200.232Z",
    fill: "#0F054C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M544.794 221.091L506.476 198.891C501.97 196.286 501.97 192.067 506.476 189.462L544.794 167.184C547.322 165.9 550.117 165.231 552.951 165.231C555.786 165.231 558.581 165.9 561.108 167.184L599.524 189.385C604.029 191.99 604.029 196.208 599.524 198.813L561.108 221.014C558.587 222.31 555.795 222.992 552.961 223.006C550.126 223.019 547.328 222.363 544.794 221.091Z",
    fill: "url(#paint11_linear_1_535)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M544.794 221.091L506.476 198.891C501.97 196.286 501.97 192.067 506.476 189.462L544.794 167.184C547.322 165.9 550.117 165.231 552.951 165.231C555.786 165.231 558.581 165.9 561.108 167.184L599.524 189.385C604.029 191.99 604.029 196.208 599.524 198.813L561.108 221.014C558.587 222.31 555.795 222.992 552.961 223.006C550.126 223.019 547.328 222.363 544.794 221.091Z",
    fill: "#0F054C"
  })))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M552.953 194.498C550.431 194.543 547.938 193.948 545.708 192.768L507.293 170.567C506.386 170.248 505.6 169.655 505.044 168.87C504.488 168.085 504.189 167.146 504.189 166.183C504.189 165.221 504.488 164.282 505.044 163.497C505.6 162.712 506.386 162.118 507.293 161.8L545.708 139.599C547.956 138.467 550.437 137.878 552.953 137.878C555.468 137.878 557.949 138.467 560.197 139.599L598.612 161.8C599.519 162.118 600.305 162.712 600.861 163.497C601.417 164.282 601.716 165.221 601.716 166.183C601.716 167.146 601.417 168.085 600.861 168.87C600.305 169.655 599.519 170.248 598.612 170.567L560.197 192.768C557.967 193.948 555.475 194.543 552.953 194.498ZM552.953 138.53C550.552 138.488 548.18 139.057 546.058 140.182L507.623 162.383C506.826 162.648 506.132 163.158 505.64 163.84C505.148 164.522 504.883 165.342 504.883 166.183C504.883 167.025 505.148 167.844 505.64 168.527C506.132 169.209 506.826 169.719 507.623 169.984L546.058 192.184C548.199 193.267 550.564 193.832 552.962 193.832C555.361 193.832 557.726 193.267 559.867 192.184L598.282 169.984C599.08 169.719 599.773 169.209 600.265 168.527C600.757 167.844 601.022 167.025 601.022 166.183C601.022 165.342 600.757 164.522 600.265 163.84C599.773 163.158 599.08 162.648 598.282 162.383L559.867 140.182C557.738 139.057 555.36 138.488 552.953 138.53Z",
    fill: "#42E8E0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M602.903 157.659V144.498L600.495 143.156C599.815 147.258 594.979 149.98 590.94 150.544L563.4 166.659L551.398 171.072L513.041 151.263L513.934 150.757C510.652 149.222 508.885 145.722 507.117 142.515L504.534 144.051L503 144.498V157.873C503.124 158.883 503.51 159.844 504.12 160.659C504.73 161.474 505.542 162.115 506.476 162.519L544.795 184.68C547.322 185.964 550.117 186.634 552.952 186.634C555.786 186.634 558.581 185.964 561.109 184.68L599.524 162.48C600.438 162.065 601.229 161.421 601.821 160.611C602.413 159.8 602.786 158.85 602.903 157.853V157.62V157.659Z",
    fill: "#42E8E0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M602.903 145.956V137.247L600.495 135.905C599.815 140.007 594.979 142.729 590.94 143.292L563.4 159.408L551.398 163.743L513.041 143.856L513.934 143.351C510.652 141.815 508.885 138.316 507.117 135.108L504.534 136.644L503 137.091V146.014C503.102 147.028 503.467 147.998 504.06 148.827C504.653 149.656 505.453 150.315 506.379 150.738L544.795 173.016C547.325 174.291 550.119 174.956 552.952 174.956C555.785 174.956 558.578 174.291 561.109 173.016L599.524 150.816C600.438 150.401 601.229 149.757 601.821 148.947C602.413 148.136 602.786 147.186 602.903 146.189V145.956Z",
    fill: "url(#paint12_linear_1_535)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M590.939 143.293L563.4 159.409L552.951 163.18V174.961C555.791 175.019 558.599 174.35 561.108 173.017L599.523 150.816C600.437 150.402 601.228 149.758 601.82 148.947C602.412 148.137 602.785 147.187 602.903 146.19V145.956V137.247L600.708 136.022H600.475C599.698 140.066 594.94 142.729 590.939 143.293Z",
    fill: "#0F054C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M513.934 143.428L550.349 122.472C551.16 122.065 552.054 121.853 552.961 121.853C553.868 121.853 554.763 122.065 555.573 122.472L591.328 143.137L590.94 143.37C594.979 142.806 599.815 140.084 600.495 135.983L560.351 113.627L548.698 110.536L539.182 116.134L507.137 135.263C508.885 138.393 510.652 141.912 513.934 143.428Z",
    fill: "url(#paint13_linear_1_535)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M552.951 111.605L548.679 110.458L539.162 116.057L507.117 135.186C508.884 138.393 510.652 141.893 513.934 143.428L550.349 122.472C551.145 122.033 552.043 121.811 552.951 121.83V111.605Z",
    fill: "#0F054C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M544.794 164.152L506.476 141.912C501.97 139.327 501.97 135.089 506.476 132.484L544.891 110.283C547.422 109.008 550.215 108.344 553.048 108.344C555.881 108.344 558.675 109.008 561.205 110.283L599.621 132.484C604.127 135.089 604.127 139.327 599.621 141.912L561.205 164.113C558.668 165.419 555.858 166.104 553.005 166.11C550.152 166.117 547.338 165.446 544.794 164.152ZM555.573 113.608C554.762 113.201 553.868 112.989 552.961 112.989C552.054 112.989 551.16 113.201 550.349 113.608L511.933 135.808C511.613 135.912 511.335 136.115 511.137 136.387C510.939 136.66 510.832 136.988 510.832 137.324C510.832 137.661 510.939 137.989 511.137 138.262C511.335 138.534 511.613 138.737 511.933 138.841L550.349 161.041C551.16 161.448 552.054 161.66 552.961 161.66C553.868 161.66 554.762 161.448 555.573 161.041L593.989 138.841C594.3 138.728 594.568 138.521 594.758 138.25C594.948 137.979 595.05 137.656 595.05 137.324C595.05 136.993 594.948 136.67 594.758 136.399C594.568 136.128 594.3 135.921 593.989 135.808L555.573 113.608Z",
    fill: "url(#paint14_linear_1_535)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M593.988 135.73L555.573 113.53C554.762 113.123 553.867 112.911 552.96 112.911C552.054 112.911 551.159 113.123 550.348 113.53L511.933 135.73C510.962 136.294 510.651 137.071 510.962 137.791C511.181 137.377 511.519 137.038 511.933 136.819L550.348 114.696C551.159 114.289 552.054 114.077 552.96 114.077C553.867 114.077 554.762 114.289 555.573 114.696L593.988 136.897C594.397 137.116 594.729 137.455 594.94 137.869C595.25 137.071 594.94 136.294 593.988 135.73Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M599.525 141.912L561.11 164.112C558.582 165.397 555.787 166.066 552.953 166.066C550.118 166.066 547.323 165.397 544.796 164.112L506.477 141.912C505.639 141.522 504.901 140.944 504.322 140.222C503.743 139.501 503.337 138.655 503.137 137.752C503.094 138.863 503.391 139.961 503.988 140.899C504.584 141.837 505.453 142.57 506.477 143.001L544.796 165.24C547.323 166.524 550.118 167.193 552.953 167.193C555.787 167.193 558.582 166.524 561.11 165.24L599.525 143.039C600.549 142.609 601.418 141.876 602.015 140.938C602.612 140 602.909 138.902 602.866 137.791C602.66 138.687 602.252 139.525 601.673 140.239C601.094 140.953 600.359 141.526 599.525 141.912Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M545.882 163.53L507.466 141.329C503.582 139.074 503.582 135.497 507.466 133.164L545.882 110.964C548.07 109.844 550.493 109.261 552.951 109.261C555.409 109.261 557.832 109.844 560.02 110.964L598.436 133.164C602.32 135.419 602.32 138.996 598.436 141.329L560.02 163.53C557.832 164.649 555.409 165.233 552.951 165.233C550.493 165.233 548.07 164.649 545.882 163.53ZM556.641 112.986C555.499 112.4 554.234 112.095 552.951 112.095C551.668 112.095 550.403 112.4 549.261 112.986L510.846 135.108C510.398 135.258 510.008 135.546 509.732 135.929C509.456 136.313 509.308 136.774 509.308 137.247C509.308 137.72 509.456 138.18 509.732 138.564C510.008 138.948 510.398 139.235 510.846 139.385L549.203 161.586C550.348 162.16 551.612 162.46 552.893 162.46C554.174 162.46 555.438 162.16 556.583 161.586L595.018 139.385C595.466 139.235 595.855 138.948 596.131 138.564C596.407 138.18 596.555 137.72 596.555 137.247C596.555 136.774 596.407 136.313 596.131 135.929C595.855 135.546 595.466 135.258 595.018 135.108L556.641 112.986Z",
    fill: "url(#paint15_linear_1_535)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M555.574 113.53C554.764 113.123 553.869 112.911 552.962 112.911C552.055 112.911 551.161 113.123 550.35 113.53L511.935 135.73C511.614 135.834 511.336 136.037 511.138 136.309C510.94 136.582 510.833 136.91 510.833 137.246C510.833 137.583 510.94 137.911 511.138 138.184C511.336 138.456 511.614 138.659 511.935 138.763L550.35 160.963C551.161 161.37 552.055 161.582 552.962 161.582C553.869 161.582 554.764 161.37 555.574 160.963L593.99 138.763C594.301 138.65 594.569 138.443 594.759 138.172C594.949 137.901 595.051 137.578 595.051 137.246C595.051 136.915 594.949 136.592 594.759 136.321C594.569 136.05 594.301 135.843 593.99 135.73L555.574 113.53Z",
    fill: "#42E8E0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M526.594 181.78L437.574 231.333L437.564 263.421L437.402 263.701L382.701 294.629L382.162 293.944L436.722 262.935L436.733 230.847L437.337 230.449L526.054 181.095L526.594 181.78Z",
    fill: "url(#paint16_linear_1_535)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M471.023 322.296L486.086 331.015V365.83L471.023 357.126V322.296Z",
    fill: "#758EF5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M455.961 331.015L471.024 339.719V357.126L455.961 348.423V331.015Z",
    fill: "#758EF5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M440.897 270.059L455.96 278.778V348.423L440.897 339.719V270.059Z",
    fill: "#758EF5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M425.819 243.948L440.897 252.652V339.719L425.819 331.015V243.948Z",
    fill: "#758EF5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M410.757 252.652L425.819 261.355V331.015L410.757 322.296V252.652Z",
    fill: "#758EF5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M395.693 191.711L410.756 200.415V322.296L395.693 313.592V191.711Z",
    fill: "#758EF5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M380.632 200.415L395.694 209.119V313.593L380.632 304.889V200.415Z",
    fill: "#758EF5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M365.569 209.118L380.632 217.822V304.888L365.569 296.185V209.118Z",
    fill: "#758EF5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M350.492 165.585L365.57 174.304V296.186L350.492 287.482V165.585Z",
    fill: "#758EF5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M335.429 122.067L350.491 130.77V287.482L335.429 278.762V122.067Z",
    fill: "#758EF5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M320.366 130.771L335.429 139.474V278.763L320.366 270.059V130.771Z",
    fill: "#758EF5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M305.304 87.2368L320.366 95.9404V270.059L305.304 261.355V87.2368Z",
    fill: "#758EF5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M290.225 78.5334L305.303 87.237V261.355L290.225 252.652V78.5334Z",
    fill: "#758EF5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M275.163 35L290.226 43.7036V252.652L275.163 243.948V35Z",
    fill: "#758EF5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M289.96 495C366.176 495 427.962 459.296 427.962 415.254C427.962 371.211 366.176 335.507 289.96 335.507C213.744 335.507 151.959 371.211 151.959 415.254C151.959 459.296 213.744 495 289.96 495Z",
    fill: "#0F054C"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M289.961 463.294C376.708 463.294 447.031 422.657 447.031 372.528C447.031 322.399 376.708 281.762 289.961 281.762C203.213 281.762 132.891 322.399 132.891 372.528C132.891 422.657 203.213 463.294 289.961 463.294Z",
    fill: "url(#paint17_linear_1_535)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M447.047 342.641H443.165C436.86 326.477 422.823 311.106 401.036 298.533C339.699 263.081 240.239 263.081 178.979 298.533C158.404 310.422 144.817 324.783 137.969 339.968H133.046V360.095C131.82 384.201 147.131 408.54 178.979 426.926C240.317 462.362 339.776 462.362 401.114 426.926C431.782 409.192 447.125 385.972 447.125 362.737L447.047 342.641Z",
    fill: "url(#paint18_linear_1_535)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M443.165 334.838C442.948 334.279 442.715 333.719 442.466 333.16V319.933H434.236V318.985C432.086 316.098 429.752 313.351 427.249 310.764V319.933H422.59V306.21C420.406 304.22 418.066 302.272 415.571 300.366V319.965H410.913V296.884C408.661 295.33 406.254 293.776 403.863 292.315V319.887H399.204V289.58C396.906 288.285 394.551 287.041 392.139 285.85V319.887H387.48V283.689C385.151 282.653 382.791 281.617 380.399 280.581V319.887H375.741V288.103H368.644V319.933H363.986V296.884H356.858V319.98H352.2V305.619H345.057V319.98H340.491V314.369H333.395V319.98H246.653V314.369H239.479V319.98H234.913V305.619H227.801V319.98H223.143V296.884H216.015V319.98H211.357V288.103H204.26V319.933H199.602V280.596C197.21 281.57 194.85 282.606 192.521 283.705V319.98H187.862V285.865C185.455 287.062 183.095 288.29 180.797 289.58V319.933H176.138V292.315C173.685 293.786 171.335 295.304 169.088 296.869V319.933H164.43V300.288C161.93 302.184 159.6 304.143 157.411 306.132V319.933H152.752V310.608C150.258 313.199 147.925 315.939 145.764 318.814V319.856H137.534V332.056H134.041V365.798C135.403 372.098 137.756 378.142 141.013 383.703V362.674H145.764V390.914C147.916 393.791 150.25 396.527 152.752 399.105V362.674H157.411V403.674C159.6 405.648 161.945 407.607 164.43 409.503V362.674H169.088V412.922C171.345 414.476 173.695 415.999 176.138 417.491V362.674H180.797V420.18C183.095 421.455 185.45 422.693 187.862 423.895V362.674H192.521V426.133C194.85 427.169 197.21 428.205 199.602 429.241V362.721H204.26V431.106C206.589 431.992 208.919 432.831 211.357 433.64V362.674H216.015V435.007C218.376 435.738 220.674 436.422 223.143 437.074V362.674H227.801V438.318C230.162 438.893 232.537 439.452 234.944 439.965V362.721H239.51V440.913C241.886 441.38 244.277 441.799 246.684 442.203V362.674H251.234V442.856C253.61 443.214 256.016 443.524 258.423 443.82V362.674H262.942V444.317C265.334 444.55 267.74 444.752 270.163 444.939V362.674H274.651V445.234C277.073 445.358 279.48 445.467 281.902 445.545V362.674H286.375V445.638C288.818 445.638 291.256 445.638 293.688 445.638V362.674H298.161V445.545C300.583 445.545 302.99 445.358 305.412 445.234V362.674H309.9V444.939C312.323 444.752 314.729 444.55 317.121 444.301V362.674H321.64V443.804C324.047 443.524 326.453 443.198 328.829 442.856V362.674H333.395V442.141C335.802 441.753 338.193 441.317 340.569 440.851V362.674H345.134V439.872C347.541 439.344 349.917 438.8 352.277 438.209V362.674H356.936V437.059C359.327 436.406 361.703 435.707 364.063 434.992V362.674H368.722V433.5C371.113 432.707 373.489 431.945 375.818 430.982V362.674H380.477V429.163C382.868 428.184 385.229 427.174 387.558 426.055V362.674H392.216V423.895C394.629 422.693 396.984 421.455 399.282 420.18V362.674H403.94V417.46C406.394 415.968 408.744 414.44 410.99 412.875V362.674H415.649V409.456C418.133 407.539 420.473 405.591 422.668 403.612V362.674H427.326V399.058C429.833 396.474 432.167 393.728 434.314 390.837V362.674H438.988V383.641C442.271 378.031 444.625 371.927 445.96 365.565V334.854L443.165 334.838Z",
    fill: "url(#paint19_linear_1_535)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M289.961 425.636C376.708 425.636 447.031 384.998 447.031 334.87C447.031 284.741 376.708 244.104 289.961 244.104C203.213 244.104 132.891 284.741 132.891 334.87C132.891 384.998 203.213 425.636 289.961 425.636Z",
    fill: "url(#paint20_linear_1_535)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M290.023 244.041C254.432 244.041 218.841 250.989 189.865 264.868L143 366.824C150.64 378.558 162.581 389.547 178.902 398.981C189.434 404.983 200.554 409.889 212.086 413.621L290.023 244.041Z",
    fill: "#91A2FA"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M334.03 247.74L253.406 423.149C272.889 425.797 292.602 426.318 312.197 424.703L386.407 263.236C369.679 255.858 352.078 250.65 334.03 247.74Z",
    fill: "#91A2FA"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M289.961 415.254C366.786 415.254 429.065 379.265 429.065 334.87C429.065 290.475 366.786 254.486 289.961 254.486C213.136 254.486 150.857 290.475 150.857 334.87C150.857 379.265 213.136 415.254 289.961 415.254Z",
    fill: "url(#paint21_linear_1_535)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M41.4907 334.528L40 333.658L282.337 193.623L283.828 194.493L41.4907 334.528Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M45.7608 336.983L44.27 336.128L286.607 196.094L288.098 196.949L45.7608 336.983Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M50.0317 339.455L48.541 338.6L290.878 198.566L292.369 199.42L50.0317 339.455Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M54.3018 341.926L52.811 341.071L295.148 201.037L296.639 201.891L54.3018 341.926Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M58.5723 344.397L57.0815 343.527L299.418 203.492L300.909 204.363L58.5723 344.397Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M62.8423 346.853L61.3516 345.998L303.688 205.963L305.179 206.818L62.8423 346.853Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M67.1128 349.324L65.6221 348.469L307.959 208.434L309.434 209.289L67.1128 349.324Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M71.3833 351.795L69.8926 350.94L312.229 210.906L313.705 211.761L71.3833 351.795Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M75.6533 354.267L74.1626 353.396L316.499 213.362L317.975 214.217L75.6533 354.267Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M79.9238 356.722L78.4331 355.867L320.77 215.833L322.245 216.688L79.9238 356.722Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M84.1783 359.193L82.7031 358.338L325.04 218.304L326.515 219.159L84.1783 359.193Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M88.4488 361.664L86.9736 360.81L329.311 220.775L330.786 221.63L88.4488 361.664Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M92.7193 364.12L91.2441 363.265L333.581 223.23L335.056 224.085L92.7193 364.12Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M96.9898 366.591L95.5146 365.736L337.852 225.702L339.327 226.557L96.9898 366.591Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M101.26 369.062L99.7847 368.207L342.122 228.173L343.597 229.028L101.26 369.062Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M105.531 371.533L104.04 370.679L346.377 230.629L347.868 231.499L105.531 371.533Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M109.801 374.005L108.31 373.135L350.647 233.1L352.138 233.955L109.801 374.005Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M114.071 376.461L112.581 375.606L354.917 235.572L356.408 236.426L114.071 376.461Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M118.341 378.932L116.851 378.077L359.187 238.042L360.678 238.897L118.341 378.932Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M122.612 381.403L121.121 380.533L363.458 240.498L364.949 241.368L122.612 381.403Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M126.882 383.858L125.392 383.003L367.728 242.969L369.219 243.824L126.882 383.858Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M131.152 386.33L129.662 385.475L371.998 245.44L373.489 246.295L131.152 386.33Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M135.423 388.801L133.932 387.946L376.269 247.912L377.76 248.767L135.423 388.801Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M139.693 391.272L138.202 390.417L380.539 250.367L382.03 251.238L139.693 391.272Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M143.963 393.727L142.473 392.873L384.81 252.838L386.3 253.693L143.963 393.727Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M148.234 396.198L146.743 395.344L389.08 255.309L390.555 256.164L148.234 396.198Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M152.504 398.67L151.014 397.815L393.351 257.781L394.826 258.635L152.504 398.67Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M156.759 401.141L155.284 400.271L397.621 260.236L399.096 261.107L156.759 401.141Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M161.029 403.597L159.554 402.742L401.891 262.708L403.366 263.562L161.029 403.597Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M165.299 406.068L163.824 405.213L406.161 265.178L407.636 266.033L165.299 406.068Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M169.57 408.539L168.095 407.684L410.432 267.649L411.907 268.504L169.57 408.539Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M173.84 411.01L172.365 410.14L414.702 270.106L416.177 270.961L173.84 411.01Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M178.11 413.466L176.635 412.611L418.957 272.577L420.447 273.431L178.11 413.466Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M182.38 415.937L180.905 415.083L423.242 275.048L424.717 275.903L182.38 415.937Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M186.651 418.409L185.176 417.554L427.497 277.504L428.988 278.374L186.651 418.409Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M190.921 420.88L189.446 420.009L431.768 279.975L433.258 280.845L190.921 420.88Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M195.192 423.335L193.701 422.48L436.038 282.446L437.529 283.301L195.192 423.335Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M199.462 425.807L197.972 424.952L440.309 284.918L441.799 285.773L199.462 425.807Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M203.733 428.278L202.242 427.423L444.579 287.373L446.07 288.243L203.733 428.278Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M208.002 430.749L206.512 429.879L448.849 289.844L450.339 290.715L208.002 430.749Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M212.273 433.204L210.782 432.35L453.119 292.315L454.61 293.17L212.273 433.204Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M216.544 435.675L215.054 434.821L457.391 294.786L458.881 295.641L216.544 435.675Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M220.814 438.147L219.323 437.293L461.66 297.258L463.151 298.113L220.814 438.147Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M225.084 440.619L223.594 439.748L465.931 299.714L467.421 300.569L225.084 440.619Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M229.355 443.074L227.864 442.219L470.201 302.185L471.692 303.04L229.355 443.074Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M233.626 445.545L232.135 444.69L474.472 304.656L475.962 305.511L233.626 445.545Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M237.895 448.016L236.404 447.161L478.741 307.111L480.232 307.982L237.895 448.016Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M242.166 450.472L240.675 449.617L483.012 309.582L484.487 310.437L242.166 450.472Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M246.436 452.943L244.945 452.089L487.282 312.054L488.757 312.909L246.436 452.943Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M250.69 455.414L249.215 454.56L491.552 314.525L493.027 315.38L250.69 455.414Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M254.961 457.886L253.485 457.031L495.822 316.981L497.297 317.851L254.961 457.886Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M259.232 460.341L257.757 459.486L500.094 319.452L501.569 320.307L259.232 460.341Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M263.503 462.812L262.027 461.957L504.364 321.923L505.839 322.778L263.503 462.812Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M267.772 465.284L266.297 464.429L508.634 324.395L510.109 325.25L267.772 465.284Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M272.042 467.755L270.551 466.885L512.888 326.851L514.378 327.721L272.042 467.755Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M276.312 470.211L274.821 469.356L517.158 329.321L518.649 330.176L276.312 470.211Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M280.583 472.681L279.092 471.827L521.429 331.792L522.919 332.647L280.583 472.681Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M284.852 475.153L283.361 474.298L525.698 334.264L527.189 335.118L284.852 475.153Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M289.123 477.623L287.632 476.753L529.969 336.719L531.459 337.589L289.123 477.623Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M293.393 480.08L291.902 479.225L534.239 339.191L535.73 340.046L293.393 480.08Z",
    fill: "#91A2FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M297.663 482.551L296.172 481.696L538.509 341.662L539.999 342.517L297.663 482.551Z",
    fill: "#91A2FA"
  })))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M191.605 283.441C245.954 252.062 334 252.062 388.334 283.441C414.298 298.455 427.839 317.913 428.988 337.574C430.23 316.111 416.689 294.414 388.334 278.032C333.985 246.637 245.923 246.637 191.605 278.032C163.25 294.414 149.678 316.111 150.951 337.574C152.1 317.913 165.688 298.439 191.605 283.441Z",
    fill: "url(#paint22_linear_1_535)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M332.96 317.851C324.677 317.116 316.343 318.512 308.751 321.907C318.068 314.136 315.92 306.194 302.307 298.081L301.297 297.491C296.882 294.858 292.142 292.815 287.198 291.414C282.518 290.049 277.676 289.322 272.803 289.253C268.15 289.283 263.518 289.889 259.013 291.056C256.498 291.699 254.096 292.414 251.808 293.201L243.05 288.134L230.162 295.579L237.367 299.76C236.093 300.444 234.805 301.159 233.485 301.92L228.826 304.656L221.683 300.521L208.794 307.966L215.938 312.1L207.04 317.245L203.561 319.265L202.614 319.794L187.831 328.342L200.72 335.802L215.503 327.254L308.394 380.967L293.595 389.516L306.484 396.96L321.282 388.412L325.708 385.863L334.606 380.719L341.873 384.915L354.762 377.47L350.103 374.813L347.448 373.258L356.004 368.316L363.271 372.512L376.16 365.068L371.501 362.41L367.806 360.265C372.883 355.836 375.57 351.36 375.912 346.852C376.284 340.117 370.694 333.383 359.141 326.648L358.364 326.181C350.589 321.617 341.926 318.776 332.96 317.851ZM246.435 314.836L250.581 312.427C260.851 306.5 270.686 306.241 280.086 311.65C285.583 314.758 288.564 317.726 289.076 320.353C289.589 322.98 287.011 325.933 281.312 329.197L276.297 332.087L246.435 314.836ZM329.233 362.674L293.564 342.112L298.72 339.128C303.621 336.02 309.316 334.401 315.118 334.465C320.232 334.714 326.133 336.786 332.82 340.682C338.783 344.133 342.003 347.319 342.479 350.241C342.96 353.162 340.351 356.271 334.715 359.566L329.233 362.674Z",
    fill: "url(#paint23_linear_1_535)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M208.717 297.506V305.775L215.86 301.641L208.717 297.506Z",
    fill: "url(#paint24_linear_1_535)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M230.161 285.119V293.388L237.366 289.3L230.161 285.119Z",
    fill: "url(#paint25_linear_1_535)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M314.45 301.656V311.478L307.99 307.515L314.45 301.656Z",
    fill: "url(#paint26_linear_1_535)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M375.99 334.87V346.868L366.3 340.869L375.99 334.87Z",
    fill: "url(#paint27_linear_1_535)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M332.96 307.391C324.677 306.657 316.343 308.053 308.751 311.448C318.068 303.677 315.92 295.73 302.307 287.606L301.297 287.031C296.882 284.399 292.142 282.356 287.198 280.954C282.52 279.582 277.677 278.855 272.803 278.794C268.15 278.824 263.518 279.429 259.013 280.597C256.498 281.229 254.096 281.944 251.808 282.742L243.05 277.675L230.162 285.119L237.367 289.3C236.093 289.984 234.805 290.699 233.485 291.461L228.826 294.196L221.683 290.062L208.794 297.507L215.938 301.641L207.04 306.785L203.561 308.79L202.614 309.334L187.831 317.882L200.72 325.342L215.503 316.794L308.472 370.508L293.673 379.056L306.562 386.501L321.36 377.953L325.786 375.404L334.684 370.259L341.951 374.456L354.839 367.011L350.181 364.353L347.526 362.799L356.082 357.857L363.349 362.053L376.238 354.608L371.579 351.951L367.883 349.806C372.961 345.376 375.648 340.9 375.989 336.393C376.362 329.658 370.772 322.923 359.218 316.188L358.442 315.737C350.648 311.15 341.956 308.303 332.96 307.391ZM246.435 304.376L250.581 301.967C260.851 296.04 270.686 295.781 280.086 301.19C285.583 304.298 288.564 307.267 289.077 309.894C289.589 312.52 287.011 315.473 281.312 318.737L276.297 321.628L246.435 304.376ZM329.233 352.215L293.626 331.653L298.782 328.668C303.683 325.561 309.378 323.941 315.18 324.006C320.294 324.255 326.195 326.327 332.882 330.223C338.845 333.673 342.065 336.859 342.541 339.781C343.022 342.703 340.414 345.811 334.777 349.106L329.233 352.215Z",
    fill: "url(#paint28_linear_1_535)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M376.206 354.624V365.083L363.317 372.528V362.068L376.206 354.624Z",
    fill: "url(#paint29_linear_1_535)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M354.762 367.011V377.471L341.873 384.915V374.455L354.762 367.011Z",
    fill: "url(#paint30_linear_1_535)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M306.498 386.501V396.961L293.594 389.516V379.056L306.498 386.501Z",
    fill: "url(#paint31_linear_1_535)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M187.754 317.882V328.357L200.643 335.802V325.342L187.754 317.882Z",
    fill: "url(#paint32_linear_1_535)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M215.425 327.254V316.794L200.642 325.342V335.802L215.425 327.254Z",
    fill: "url(#paint33_linear_1_535)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M215.424 316.794V327.254L299.34 375.745L308.393 370.508L215.424 316.794Z",
    fill: "url(#paint34_linear_1_535)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M291.887 259.226C286.404 259.34 280.983 258.045 276.141 255.465C271.762 252.947 269.355 249.528 269.355 245.86C269.355 242.192 271.762 238.788 276.141 236.255C284.822 231.25 298.953 231.25 307.649 236.255C312.012 238.788 314.419 242.208 314.419 245.86C314.419 249.512 312.012 252.947 307.649 255.465C302.802 258.045 297.376 259.34 291.887 259.226ZM291.887 234.203C286.702 234.108 281.578 235.333 276.995 237.762C273.191 239.969 271.095 242.845 271.095 245.86C271.095 248.875 273.191 251.766 277.011 253.973C285.21 258.713 298.564 258.713 306.779 253.973C310.583 251.766 312.695 248.891 312.695 245.86C312.695 242.829 310.583 239.969 306.779 237.762C302.197 235.331 297.072 234.106 291.887 234.203Z",
    fill: "#91A2FA"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M301.22 251.253C298.334 252.722 295.142 253.487 291.903 253.487C288.665 253.487 285.473 252.722 282.586 251.253C277.431 248.284 277.431 243.482 282.586 240.482C285.473 239.014 288.665 238.248 291.903 238.248C295.142 238.248 298.334 239.014 301.22 240.482C306.36 243.451 306.36 248.284 301.22 251.253Z",
    fill: "#97A6FC"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M346.282 219.764L337.043 214.433L352.773 205.341L362.028 210.672L346.282 219.764Z",
    fill: "#91A2FA"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M329.667 211.341L318.021 207.906L328.13 196.452L339.776 199.886L329.667 211.341Z",
    fill: "#91A2FA"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M309.357 206.274L296.453 205.093L299.931 192.395L312.836 193.576L309.357 206.274Z",
    fill: "#91A2FA"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M287.337 205.093L274.417 206.274L270.938 193.576L283.843 192.395L287.337 205.093Z",
    fill: "#91A2FA"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M265.753 207.906L254.106 211.341L244.013 199.871L255.643 196.452L265.753 207.906Z",
    fill: "#91A2FA"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M246.73 214.433L237.49 219.764L221.76 210.672L230.999 205.341L246.73 214.433Z",
    fill: "#91A2FA"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M315.444 234.141L312.198 232.26L335.677 218.692L338.923 220.572L315.444 234.141Z",
    fill: "#91A2FA"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M308.006 230.504L303.922 229.292L319 212.195L323.084 213.408L308.006 230.504Z",
    fill: "#91A2FA"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M299.015 228.375L294.48 227.955L299.667 209.01L304.201 209.429L299.015 228.375Z",
    fill: "#91A2FA"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M289.31 227.955L284.775 228.375L279.573 209.429L284.108 209.01L289.31 227.955Z",
    fill: "#91A2FA"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M279.853 229.292L275.769 230.504L260.69 213.408L264.79 212.195L279.853 229.292Z",
    fill: "#91A2FA"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M271.591 232.26L268.345 234.141L244.866 220.572L248.112 218.692L271.591 232.26Z",
    fill: "#91A2FA"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M265.302 236.55L263.221 238.912L233.64 230.193L235.72 227.831L265.302 236.55Z",
    fill: "#91A2FA"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M261.621 241.756L260.906 244.367L228.11 241.368L228.825 238.741L261.621 241.756Z",
    fill: "#91A2FA"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M260.906 247.352L261.621 249.978L228.825 252.978L228.11 250.351L260.906 247.352Z",
    fill: "#91A2FA"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M263.221 252.823L265.302 255.185L235.72 263.889L233.64 261.526L263.221 252.823Z",
    fill: "#91A2FA"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M268.345 257.594L271.591 259.475L248.112 273.043L244.866 271.162L268.345 257.594Z",
    fill: "#91A2FA"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M384.11 201.813C418.63 225.872 420.556 260.267 389.934 285.507L402.356 296.962C444.609 266.531 443.677 222.717 399.608 192.83L384.11 201.813Z",
    fill: "#97A6FC"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M310.568 314.168C274.061 317.478 235.395 311.059 207.273 294.771C201.132 291.279 195.403 287.109 190.192 282.338L169.12 286.534C175.899 293.206 183.527 298.954 191.807 303.63C227.382 324.177 277.213 331.482 322.898 325.56L310.568 314.168Z",
    fill: "#91A2FA"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M151.852 257.47L172.924 253.274C169.197 233.193 180.688 212.351 207.273 196.964C251.311 171.522 321.112 170.061 368.132 192.566L383.583 183.645C328.006 156.229 244.401 157.689 191.853 188.059C159.103 206.974 145.78 232.867 151.852 257.47Z",
    fill: "#97A6FC"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M278.983 291.585L270.737 286.829L376.61 225.64L384.856 230.396L278.983 291.585Z",
    fill: "#97A6FC"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M290.691 298.361L282.445 293.59L328.472 266.997L336.717 271.768L290.691 298.361Z",
    fill: "#97A6FC"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M303.223 305.604L294.978 300.832L368.241 258.511L376.486 263.267L303.223 305.604Z",
    fill: "#97A6FC"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M315.568 312.722L307.307 307.966L364.343 275.017L372.588 279.773L315.568 312.722Z",
    fill: "#97A6FC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_535",
    x1: 513.95,
    y1: 530.116,
    x2: 593.266,
    y2: 575.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#AAADF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#7C83E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_535",
    x1: 504.002,
    y1: 547.437,
    x2: 603.935,
    y2: 547.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D3D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#C5C4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0BFF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_535",
    x1: 52360,
    y1: 9528.62,
    x2: 54111.4,
    y2: 12071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#AAADF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#7C83E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_535",
    x1: 51817,
    y1: 14075.8,
    x2: 56956.7,
    y2: 14075.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D3D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#C5C4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0BFF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_535",
    x1: 364.959,
    y1: 453.479,
    x2: 535.052,
    y2: 453.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5778FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1042,
    stopColor: "#567FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2607,
    stopColor: "#5394FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4503,
    stopColor: "#4DB6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6638,
    stopColor: "#46E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7742,
    stopColor: "#42FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_535",
    x1: 43049.8,
    y1: 11841.4,
    x2: 44801.1,
    y2: 14383.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#AAADF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#7C83E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_535",
    x1: 42531.6,
    y1: 17439.7,
    x2: 47674.8,
    y2: 17439.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D3D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#C5C4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0BFF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_535",
    x1: 43049.8,
    y1: 10492.5,
    x2: 44800.6,
    y2: 13034.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#AAADF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#7C83E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_535",
    x1: 42531.6,
    y1: 15503.9,
    x2: 47674.8,
    y2: 15503.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D3D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#C5C4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0BFF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_535",
    x1: 224.231,
    y1: 469.7,
    x2: 54.1412,
    y2: 470.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5778FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1042,
    stopColor: "#567FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2607,
    stopColor: "#5394FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4503,
    stopColor: "#4DB6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6638,
    stopColor: "#46E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7742,
    stopColor: "#42FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_535",
    x1: 26610.7,
    y1: 5161.86,
    x2: 28362.1,
    y2: 7702.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#AAADF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#7C83E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_535",
    x1: 26074.4,
    y1: 7900.77,
    x2: 31208.5,
    y2: 7900.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D3D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#C5C4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0BFF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_535",
    x1: 26610.7,
    y1: 3948.11,
    x2: 28367.1,
    y2: 6490.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#AAADF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#7C83E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_535",
    x1: 517.702,
    y1: 116.854,
    x2: 588.41,
    y2: 157.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#5761D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#7A82E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#979CF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ACAFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#B8BAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_535",
    x1: 26099.3,
    y1: 6150.71,
    x2: 31238.3,
    y2: 6150.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D3D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#C5C4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0BFF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1_535",
    x1: 25381.1,
    y1: 5963.93,
    x2: 30207.3,
    y2: 5963.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D3D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#C5C4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0BFF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1_535",
    x1: 411.839,
    y1: 311.499,
    x2: 496.886,
    y2: 164.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5778FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1042,
    stopColor: "#567FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2607,
    stopColor: "#5394FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4503,
    stopColor: "#4DB6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6638,
    stopColor: "#46E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7742,
    stopColor: "#42FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1_535",
    x1: 99913,
    y1: -16197.8,
    x2: 118875,
    y2: 14589.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35068C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#40DDDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#3AAEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#3484A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2F6195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2B4486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#282E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#261E71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#24156C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#24126A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1_535",
    x1: 109.179,
    y1: 362.675,
    x2: 420.214,
    y2: 362.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3671E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#91A2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#8B97F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#7366C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#654CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#4127A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#260672"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1_535",
    x1: 22161.8,
    y1: 45113.4,
    x2: 84817.2,
    y2: 45113.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42E8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#43E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#4E9CDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#5472D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1_535",
    x1: 102648,
    y1: -22241.8,
    x2: 121610,
    y2: 8545.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#654CB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#40DDDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#3AAEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#3484A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2F6195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2B4486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#282E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#261E71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#24156C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#24126A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1_535",
    x1: 265.442,
    y1: 212.227,
    x2: 343.293,
    y2: 600.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42E8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#40DDDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#3AAEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#3484A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2F6195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2B4486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#282E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#261E71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#24156C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#24126A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1_535",
    x1: 150.873,
    y1: 296.03,
    x2: 429.065,
    y2: 296.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180D5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1_535",
    x1: 20001.9,
    y1: 28406.6,
    x2: 42857.5,
    y2: 28406.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180D5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1_535",
    x1: 1070.96,
    y1: 2185.27,
    x2: 1075.07,
    y2: 2244.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B237D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#40DDDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#3AAEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#3484A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2F6195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2B4486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#282E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#261E71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#24156C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#24126A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1_535",
    x1: 1199.55,
    y1: 2106.98,
    x2: 1203.53,
    y2: 2166.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C247E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#40DDDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#3AAEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#3484A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2F6195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2B4486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#282E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#261E71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#24156C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#24126A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1_535",
    x1: 1500.15,
    y1: 2571.07,
    x2: 1507.74,
    y2: 2655.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180D5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1_535",
    x1: 2503.47,
    y1: 3407.33,
    x2: 2587.26,
    y2: 3421.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180D5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1_535",
    x1: 20982.3,
    y1: 26289.2,
    x2: 90746.6,
    y2: 51600.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#654DB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0899,
    stopColor: "#40DDDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E9E9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#654DB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2F6195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2B4486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#282E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#261E71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#24156C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#24126A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1_535",
    x1: 3177.8,
    y1: 5207.83,
    x2: 3316.46,
    y2: 5228.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180D5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1_535",
    x1: 2978.49,
    y1: 5362.92,
    x2: 3117.15,
    y2: 5383.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180D5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1_535",
    x1: 2520.2,
    y1: 5510.32,
    x2: 2691.03,
    y2: 5536.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180D5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1_535",
    x1: 1590.94,
    y1: 4620.31,
    x2: 1615.03,
    y2: 4912.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C247D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#40DDDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#3AAEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#3484A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2F6195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2B4486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#282E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#261E71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#24156C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#24126A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1_535",
    x1: 1942.09,
    y1: 4878.14,
    x2: 1965.01,
    y2: 5179.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180D5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1_535",
    x1: 14272.3,
    y1: 14027.1,
    x2: 14396.3,
    y2: 17334.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91A2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0199,
    stopColor: "#91A2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#654DB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#654DB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#654DB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#654CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#35068C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#35068C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#35068C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#35068C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#35068C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.d19204fa8f898a1905a9f4aa994b95d0.svg";
export { ForwardRef as ReactComponent };